import axios from '../api/axiosInstance';

export const fetchShopSettlements = (params = {}) => {
  return axios.get('/shop-settlements', { params });
};

export const fetchShopSettlement = (id) => {
  return axios.get(`/shop-settlements/${id}`);
};

export const fetchPendingShopOrders = (params = {}) => {
  return axios.get('/shop-settlements/pending', { params });
};

export const createShopSettlement = (data) => {
  return axios.post('/shop-settlements', data);
};

export const updateShopSettlement = (id, data) => {
  return axios.put(`/shop-settlements/${id}`, data);
};

export const updateShopSettlementCommission = (id, data) => {
  return axios.put(`/shop-settlements/${id}/commission`, data);
};
